import React from 'react';
import PropTypes from 'prop-types';

const Section = ({title, children}) => (
    <div className="mb-5">
        {title && <h3 className="mb-4">{title}</h3>}
        {children}
    </div>
);

Section.propTypes = {
    title: PropTypes.string,
    children: PropTypes.node.isRequired,
};

Section.defaultProps = {
    title: null,
};

export default Section;



// WEBPACK FOOTER //
// ./src/components/layouts/Section.js